/**
 * Muestra un mensaje de notificación temporal.
 * @param {HTMLElement} container - El elemento DOM donde se mostrará la notificación (ej. un div vacío).
 * @param {string} message - El mensaje a mostrar.
 * @param {string} type - El tipo de notificación ('success', 'error', 'info', 'warning').
 * @param {number} duration - Duración en milisegundos (por defecto 3000ms).
 */
export function Notification(container, message, type = 'info', duration = 3000) {
    if (!container) {
        console.warn('Contenedor de notificación no encontrado. Mensaje:', message);
        return;
    }

    const notificationElement = document.createElement('div');
    notificationElement.textContent = message;
    notificationElement.className = `notification ${type} p-3 mb-4 rounded-lg shadow-md text-white transition-opacity duration-500`; // Clases base

    // Añadir clases de Tailwind CSS para estilos de fondo según el tipo
    switch (type) {
        case 'success':
            notificationElement.classList.add('bg-green-500');
            break;
        case 'error':
            notificationElement.classList.add('bg-red-500');
            break;
        case 'info':
            notificationElement.classList.add('bg-blue-500');
            break;
        case 'warning':
            notificationElement.classList.add('bg-yellow-500');
            break;
        default:
            notificationElement.classList.add('bg-gray-500');
    }

    // Limpiar cualquier notificación anterior en el mismo contenedor
    container.innerHTML = '';
    container.appendChild(notificationElement);

    // Ocultar la notificación después de la duración especificada
    setTimeout(() => {
        notificationElement.style.opacity = '0';
        setTimeout(() => {
            notificationElement.remove();
        }, 500); // Esperar a que la transición de opacidad termine
    }, duration);
}
